import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { boxShadow, defaultContainerSize, mq } from '../../../mixins';
import {
  Headline1,
  Headline4,
  ParagraphM,
  ParagraphS,
} from '../../../../components/core/Typography/Typography';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.core_white};
`;

export const Inner = styled.section`
  ${defaultContainerSize};
  padding-top: 1.5rem;
  padding-bottom: 5rem;
  position: relative;
  z-index: 0;

  ${mq.small(css`
    padding-top: 2rem;
    padding-bottom: 4rem;
  `)};

  ${mq.xLarge(css`
    padding-top: 2.5rem;
    padding-bottom: 8.75rem;
  `)};
`;

export const CareerContent = styled.div`
  width: 100%;
  margin: 2rem 0 0 0;
`;

export const CareerPosition = styled.h1`
  ${Headline1};
  color: ${({ theme }) => theme.colors.black};
  margin: 0;

  ${mq.medium(css`
    font-size: 4rem;
    line-height: 5rem;
  `)};
`;

export const CareerDetails = styled.p`
  ${ParagraphS};
  color: ${({ theme }) => theme.colors.black};
  display: flex;
  flex-wrap: wrap;
  margin: 0;
`;

export const CareerSalary = styled.span`
  ${ParagraphM};
  font-family: ${({ theme }) => theme.font.questrial};
  color: ${({ theme }) => theme.colors.primary};
  order: 1;
  flex: 0 0 100%;
  margin-bottom: 1rem;

  ${mq.medium(css`
    margin-left: 0.5rem;
    margin-bottom: 0;
    flex: 0 0 auto;
    order: 2;
  `)};
`;

export const CareerLocationWorkingHours = styled.span`
  ${ParagraphS};
  order: 2;
  flex: 0 0 100%;

  ${mq.medium(css`
    flex: 0 0 auto;
    order: 1;
  `)};
`;

export const CareerDescription = styled.div`
  margin-top: 2.5rem;
  position: relative;
  z-index: 1;

  ${mq.medium(css`
    padding-left: 4rem;
  `)};
`;

export const CareerParagraph = styled.p`
  ${ParagraphM};
  color: ${({ theme }) => theme.colors.dark_grey};
  max-width: 48rem;
  margin: 0;
`;

export const CareerSubtitle = styled.h2`
  ${Headline4};
  margin: 3rem 0 1rem 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const CareerList = styled.ul`
  margin: 0;
  padding-left: 3.5rem;
`;

export const CareerListItem = styled.li`
  ${ParagraphM};
  color: ${({ theme }) => theme.colors.black};
  margin: 0 0 1rem 0;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const CareerApply = styled.a`
  color: ${({ theme }) => theme.colors.core_white};
  font-size: 1.25rem;
  line-height: 2rem;
  border: none;
  border-radius: 4rem;
  text-align: center;
  box-shadow: none;
  position: relative;
  padding: 0.75rem 0;
  font-family: ${({ theme }) => theme.font.questrial};
  background-color: ${({ theme }) => theme.colors.primary};
  transition: background-color 300ms ease-in-out;
  text-decoration: none;
  display: block;
  margin-top: 5rem;
  width: 100%;
  ${boxShadow};

  &:before {
    content: '';
    z-index: -1;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 4rem;
    background: linear-gradient(67.33deg, #0e4ed7 -19.99%, #f94743 98.54%);
  }

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: transparent;
  }

  ${mq.xSmall(css`
    display: inline-block;
  `)};

  ${mq.small(css`
    min-width: 11rem;
    width: auto;
    padding: 0.75rem 3rem;
  `)};

  ${mq.xLarge(css`
    padding: 0.75rem 5rem;
  `)};
`;
